import React from 'react';
import { Car, Calculator, Camera, FileText, Users, Bell, Receipt, Rocket } from 'lucide-react';
import FeatureCard from './FeatureCard';

const FeatureSection: React.FC = () => {
  const features = [
    {
      icon: <Rocket className="h-10 w-10 text-blue-600" />,
      title: 'Instant Hive Creation',
      description: 'Create and configure your parking lot instantly — add area, slot count, location, GST details, and begin operations immediately.',
    },
    {
      icon: <Calculator className="h-10 w-10 text-blue-600" />,
      title: 'Flexible Pricing Models',
      description: 'Hourly slabs, daily charges, weekday/weekend rates, scheduled pricing updates, and monthly passes — all automated.',
    },
    {
      icon: <Camera className="h-10 w-10 text-blue-600" />,
      title: 'Lightning-Fast Entry & Exit',
      description: 'Smart scanning with automated charge calculation. Fast. Transparent. Efficient. Every movement recorded.',
    },
    {
      icon: <Receipt className="h-10 w-10 text-blue-600" />,
      title: 'Digital Payment Support',
      description: 'UPI and online payment modes eliminate cash handling and leakage. Every transaction secured and traceable.',
    },
    {
      icon: <Users className="h-10 w-10 text-blue-600" />,
      title: 'Team Member Access',
      description: 'Secure login and PIN protection for accountability. Control access and monitor staff performance in real-time.',
    },
    {
      icon: <Bell className="h-10 w-10 text-blue-600" />,
      title: 'Real-time Monitoring',
      description: 'Check-in/out logs, collection summaries, and exportable PDF records for auditing. Live operational visibility.',
    },
    {
      icon: <Car className="h-10 w-10 text-blue-600" />,
      title: 'Amenities Listing',
      description: 'CCTV, EV charging, valet, and covered parking visibility for customer satisfaction and premium positioning.',
    },
    {
      icon: <FileText className="h-10 w-10 text-blue-600" />,
      title: 'Scalable Operations',
      description: 'Support multiple parking sites and large-volume peak intervals with offline-resilient architecture.',
    },
  ];

  return (
    <section id="features" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Core Capabilities That Define Park Hive
          </h2>
          <p className="text-lg text-gray-600">
            Park Hive brings together every essential parking function into one intelligent mobile platform designed for everyday complexity.
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureSection;